var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":_vm.md}},[_c('v-container',[_c('v-row',[_c('h6',[_c('b',[_vm._v(_vm._s(_vm.item.elevator.name))])])]),_c('v-row',[_c('p',[_vm._v(_vm._s(_vm.item.elevator.zip)+", "+_vm._s(_vm.item.elevator.city))])]),_c('v-row',[_vm._v(" "+_vm._s(_vm.customer())+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }